module.exports = __webpack_public_path__ + "static/media/linkedin.85635f6c.gif";